export const COMPETITORS = "common.competitors";
export const DEFAULT_TOOLTIP = "activation.home.header.multiple_sets.default.hp.tooltip";
export const UNSET_DEFAULT_TOOLTIP = "activation.unset.as.default.already.text";
export const SUBSCRIBE_TOOLTIP = "activation.home.list.item.subscribe.tooltip";
export const SUBSCRIBE_SETTINGS_TOOLTIP = "activation.home.list.item.unsubscribe.tooltip";
